export const STATUS = {
  default: 'default',
  success: 'success',
  error: 'error',
  warning: 'warning',
}

export const ICON_PLACEMENT = {
  left: 'left',
  right: 'right',
}

export const TYPES = {
  text: 'text',
  number: 'number',
  password: 'password',
  tel: 'tel',
  email: 'email',
  url: 'url',
}

export const ERROR_MESSAGES = {
  name: {
    required: 'Tu nombre es necesario'
  },
  email: {
    required: 'Tu email es necesario',
    format: 'Ingresa un correo válido'
  },
}